import { render } from "./AsvancedPortfolioForm.vue?vue&type=template&id=6132d989"
import script from "./AsvancedPortfolioForm.vue?vue&type=script&lang=js"
export * from "./AsvancedPortfolioForm.vue?vue&type=script&lang=js"

import "./AsvancedPortfolioForm.vue?vue&type=style&index=0&id=6132d989&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__